{
    "save": "Guardar",
    "cancel": "Cancelar",
    "back": "Atrás",
    "next": "Siguiente",
    "submit": "Enviar",
    "loading": "Cargando...",
    "language": "Idioma",
    "languageDescription": "Elija el idioma de los menús, los botones y los recordatorios.",
    "profile": {
        "title": "Perfil",
        "description": "Gestione su perfil y sus preferencias",
        "contactDetails": "Datos de contacto",
        "languageGroup": "Idioma",
        "otherActions": "Otras acciones",
        "changePassword": "Cambiar la contraseña",
        "logout": "Cerrar sesión",
        "incompleteTitle": "Perfil incompleto",
        "incompleteMessage": "Para usar Patient Watch, complete primero su perfil rellenando todos los campos indicados como pendientes."
    },
    "nav": {
        "diaries": "Diarios"
    }
}
